import { Box, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';

function NhStyleFingerprintFilters({
  nameQuery,
  eligibility,
  onNameChange,
  onEligibilityChange,
}) {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
      <TextField
        label="Name"
        value={nameQuery}
        onChange={onNameChange}
        size="small"
      />
      <ToggleButtonGroup
        exclusive
        value={eligibility}
        onChange={onEligibilityChange}
        aria-label="Eligibility"
      >
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="eligible">Eligible</ToggleButton>
        <ToggleButton value="ineligible">Ineligible</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default NhStyleFingerprintFilters;
